// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="./ga.d.ts" />

import { useCallback } from 'react'
import { useLocation } from 'react-router'

const gaId = import.meta.env.VITE_GA_ID
const isProd = import.meta.env.VITE_APP_MODE === 'production'

const useGoogleAnalytics = () => {
    const location = useLocation()

    const sendPageView = useCallback(() => {
        if (isProd && !window?.gtag) return
        window.gtag('config', gaId, {
            page_path: location.pathname + location.search,
        })
    }, [location])

    return {
        sendPageView,
    }
}

export default useGoogleAnalytics
